import CP from '../../assets/icons/check-point.svg';
import CPLogoWatermark from '../../assets/icons/check-point-logo-watermark.svg';
import ExposureMgmt from '../../assets/icons/check-point-exposure-management.svg';
import Home from '../../assets/icons/home.svg';
import HomeNg from '../../assets/icons/home-ng.svg';
import Asset from '../../assets/icons/asset.svg';
import Alert from '../../assets/icons/alert.svg';
import Remediation from '../../assets/icons/remediation.svg';
import ThreatInvestigation from '../../assets/icons/threat-investigation.svg';
import IoCs from '../../assets/icons/iocs.svg';
import Siren from '../../assets/icons/siren.svg';
import Radar from '../../assets/icons/radar.svg';
import Investigation from '../../assets/icons/investigation.svg';
import InvestigationRequest from '../../assets/icons/investigation-request.svg';
import Chain from '../../assets/icons/chain.svg';
import Monitor from '../../assets/icons/monitor.svg';
import Shield from '../../assets/icons/shield.svg';
import ShieldTarget from '../../assets/icons/shield-target.svg';
import AcceptedShield from '../../assets/icons/shield-accepted.svg';
import RejectedShield from '../../assets/icons/shield-rejected.svg';
import ShieldEnforced from '../../assets/icons/shield-enforced.svg';
import ShieldAvailable from '../../assets/icons/shield-available.svg';
import ShieldUnavailable from '../../assets/icons/shield-unavailable.svg';
import ThreatIntel from '../../assets/icons/ti.svg';
import ThreatIntelNg from '../../assets/icons/ti-ng.svg';
import Books from '../../assets/icons/books.svg';
import Dashboard from '../../assets/icons/dashboard.svg';
import GridView from '../../assets/icons/grid-view.svg';
import TableList from '../../assets/icons/table-list.svg';
import Gear from '../../assets/icons/gear.svg';
import Tenants from '../../assets/icons/tenants.svg';
import Arrow from '../../assets/icons/arrow.svg';
import PrevArrow from '../../assets/icons/arrow-prev.svg';
import NextArrow from '../../assets/icons/arrow-next.svg';
import DownArrow from '../../assets/icons/arrow-down.svg';
import Search from '../../assets/icons/search.svg';
import Notification from '../../assets/icons/notification.svg';
import OnlineHelpIcon from '../../assets/icons/online-help.svg';
import Info from '../../assets/icons/info.svg';
import Lock from '../../assets/icons/lock.svg';
import Target from '../../assets/icons/target.svg';
import Fire from '../../assets/icons/fire.svg';
import SelectedCheckbox from '../../assets/icons/checkbox/checkbox-selected.svg';
import SelectedDisabledCheckbox from '../../assets/icons/checkbox/checkbox-selected-disabled.svg';
import IndeterminateCheckbox from '../../assets/icons/checkbox/checkbox-indeterminate.svg';
import IndeterminateDisabledCheckbox from '../../assets/icons/checkbox/checkbox-indeterminate-disabled.svg';
import Checkbox from '../../assets/icons/checkbox/checkbox.svg';
import DisabledCheckbox from '../../assets/icons/checkbox/checkbox-disabled.svg';
import Add from '../../assets/icons/add-icon.svg';
import AddBare from '../../assets/icons/add.svg';
import Archive from '../../assets/icons/archive.svg';
import Delete from '../../assets/icons/delete.svg';
import Edit from '../../assets/icons/edit.svg';
import Edited from '../../assets/icons/edited.svg';
import EditPage from '../../assets/icons/edit-page.svg';
import Filters from '../../assets/icons/filters-icon.svg';
import FiltersBare from '../../assets/icons/filters.svg';
import ThreeDots from '../../assets/icons/three-dots.svg';
import Email from '../../assets/icons/email.svg';
import Clock from '../../assets/icons/clock.svg';
import Coins from '../../assets/icons/coins.svg';
import Close from '../../assets/icons/close.svg';
import Collapse from '../../assets/icons/collapse.svg';
import Expand from '../../assets/icons/expand.svg';
import Shrink from '../../assets/icons/shrink.svg';
import ExpandWidth from '../../assets/icons/expand-width.svg';
import ShrinkWidth from '../../assets/icons/shrink-width.svg';
import Triangle from '../../assets/icons/triangle.svg';
import TriangleGrab from '../../assets/icons/triangle-grab.svg';
import VeryHighIcon from '../../assets/icons/severities/very_high.svg';
import HighIcon from '../../assets/icons/severities/high.svg';
import MediumIcon from '../../assets/icons/severities/medium.svg';
import LowIcon from '../../assets/icons/severities/low.svg';
import InfoIcon from '../../assets/icons/severities/info.svg';
import Tag from '../../assets/icons/tag.svg';
import Ribbon from '../../assets/icons/ribbon.svg';
import RibbonOutlined from '../../assets/icons/ribbon-outlined.svg';
import Picture from '../../assets/icons/picture.svg';
import Globe from '../../assets/icons/globe.svg';
import Ip from '../../assets/icons/ip.svg';
import Cloud from '../../assets/icons/cloud.svg';
import Subdomain from '../../assets/icons/subdomain.svg';
import Organization from '../../assets/icons/origanization.svg';
import CloudAccount from '../../assets/icons/cloud-account.svg';
import Report from '../../assets/icons/report.svg';
import Upload from '../../assets/icons/upload.svg';
import Pdf from '../../assets/icons/pdf.svg';
import Share from '../../assets/icons/share.svg';
import Chat from '../../assets/icons/chat.svg';
import ChatTakedown from '../../assets/icons/chat-takedown.svg';
import Attachments from '../../assets/icons/attachments.svg';
import Refresh from '../../assets/icons/refresh.svg';
import Reload from '../../assets/icons/reload.svg';
import CheckedRadio from '../../assets/icons/radio/radio-selected.svg';
import CheckedDisabledRadio from '../../assets/icons/radio/radio-selected-disabled.svg';
import UnCheckedRadio from '../../assets/icons/radio/radio.svg';
import UnCheckedDisabledRadio from '../../assets/icons/radio/radio-disabled.svg';
import Copy from '../../assets/icons/copy.svg';
import Download from '../../assets/icons/download.svg';
import Save from '../../assets/icons/save.svg';
import Check from '../../assets/icons/check.svg';
import CheckOutlined from '../../assets/icons/check-outlined.svg';
import ExportToCSV from '../../assets/icons/export-csv.svg';
import ExportToXlsx from '../../assets/icons/xlsx.svg';
import Calendar from '../../assets/icons/calendar.svg';
import DiscoveryPath from '../../assets/icons/discovery-path.svg';
import ParkedDomain from '../../assets/icons/parked-domain.svg';
import Play from '../../assets/icons/play.svg';
import Thumb from '../../assets/icons/thumb.svg';
import Success from '../../assets/icons/success.svg';
import ClipboardCheck from '../../assets/icons/clipboard-check.svg';
import Fail from '../../assets/icons/fail.svg';
import InProgress from '../../assets/icons/in-progress.svg';
import Error from '../../assets/icons/error.svg';
import Abort from '../../assets/icons/abort.svg';
import Warning from '../../assets/icons/warning.svg';
import WarningHex from '../../assets/icons/warning-hex.svg';
import Fingerprint from '../../assets/icons/fingerprint.svg';
import Minimize from '../../assets/icons/minimize.svg';
import Popular from '../../assets/icons/popular.svg';
import History from '../../assets/icons/history.svg';
import Location from '../../assets/icons/location.svg';
import RelatedAlert from '../../assets/icons/alert_ti.svg';
import Phishing from '../../assets/icons/phishing.svg';
import Phone from '../../assets/icons/phone.svg';
import Work from '../../assets/icons/work.svg';
import Users from '../../assets/icons/users.svg';
import Copyright from '../../assets/icons/copyright.svg';
import WorkAlert from '../../assets/icons/work_alert.svg';
import Imposter from '../../assets/icons/imposter.svg';
import Other from '../../assets/icons/other.svg';
import ExposedFile from '../../assets/icons/exposed_file.svg';
import Escalation from '../../assets/icons/escalation.svg';
import Ban from '../../assets/icons/ban.svg';
import Pin from '../../assets/icons/pin.svg';
import PinOff from '../../assets/icons/pin-off.svg';
import ArchiveRestore from '../../assets/icons/archive-restore.svg';
import Flag from '../../assets/icons/flag.svg';
import Bug from '../../assets/icons/bug.svg';
import Trademark from '../../assets/icons/trademark.svg';
import PenSquare from '../../assets/icons/pen-square.svg';
import Link from '../../assets/icons/link.svg';
import LinkCircle from '../../assets/icons/link-circle.svg';
import Visibility from '../../assets/icons/visibility.svg';
import VisibilityOff from '../../assets/icons/visibility-off.svg';
import ArrowDirection from '../../assets/icons/arrow-direction.svg';
import DoneAll from '../../assets/icons/done-all.svg';
import Image from '../../assets/icons/image.svg';
import AccountCircle from '../../assets/icons/account_circle.svg';
import ArtificialIntelligence from '../../assets/icons/ai.svg';
import AiSparkle from '../../assets/icons/ai-sparkle.svg';
import StarSparkle from '../../assets/icons/star-sparkle.svg';
import Star from '../../assets/icons/star.svg';
import Severity from '../../assets/icons/severity.svg';
import CalendarDefault from '../../assets/icons/calendar_default.svg';
import Folder from '../../assets/icons/folder.svg';
import FolderOpen from '../../assets/icons/folder_open.svg';
import Heart from '../../assets/icons/heart.svg';
import HeartPlus from '../../assets/icons/heart_plus.svg';
import MoveTo from '../../assets/icons/move_to.svg';
import OpenInBrowser from '../../assets/icons/open_in_browser.svg';
import Settings from '../../assets/icons/settings.svg';
import ThumbDown from '../../assets/icons/thumb_down.svg';
import Translate from '../../assets/icons/translate.svg';
import Theme from '../../assets/icons/theme.svg';
import Sun from '../../assets/icons/sun.svg';
import Moon from '../../assets/icons/moon.svg';
import CreateAlert from '../../assets/icons/create_alert.svg';
import CreateAlertFilled from '../../assets/icons/create_alert_filled.svg';
import AlertActive from '../../assets/icons/saved-query/alert-active.svg';
import Plus from '../../assets/icons/plus.svg';
import Send from '../../assets/icons/send.svg';
import LockOpen from '../../assets/icons/lock-open.svg';
import Eraser from '../../assets/icons/eraser.svg';
import PanoptesFullEye from '../../assets/icons/cyber-eye.svg';
import Accepted from '../../assets/icons/accepted.svg';
import Owner from '../../assets/icons/owner.svg';
import GraduationCap from '../../assets/icons/graduation-cap.svg';
import Alpha from '../../assets/icons/alpha.svg';
import Beta from '../../assets/icons/beta.svg';
import Map from '../../assets/icons/map.svg';
import Pending from '../../assets/icons/pending.svg';
import VT from '../../assets/icons/vt.svg';
import FilledFlag from '../../assets/icons/filled-flag.svg';
import OutlinedFlag from '../../assets/icons/outlined-flag.svg';

import Exploit from '../../assets/icons/exploit.svg';
import DropletFilled from '../../assets/icons/droplet-filled.svg';
import DropletOutlined from '../../assets/icons/droplet-outlined.svg';
import PlayBare from '../../assets/icons/play-bare.svg';
import Wrench from '../../assets/icons/wrench.svg';
import Door from '../../assets/icons/door.svg';
import LogOut from '../../assets/icons/log-out.svg';
import Network from '../../assets/icons/network.svg';
import Ticket from '../../assets/icons/ticket.svg';
import Broadcast from '../../assets/icons/broadcast.svg';
import CursorClick from '../../assets/icons/cursor-click.svg';
// social media
import Instagram from '../../assets/icons/social-media/sm_instagram.svg';
import Facebook from '../../assets/icons/social-media/sm_fb.svg';
import X from '../../assets/icons/social-media/sm_x.svg';
import LinkedIn from '../../assets/icons/social-media/sm_linkedIn.svg';
import Telegram from '../../assets/icons/social-media/sm_telegram.svg';
import Tiktok from '../../assets/icons/social-media/sm_tiktok.svg';
import Slack from '../../assets/icons/social-media/sm_slack.svg';
import Teams from '../../assets/icons/social-media/sm_teams.svg';
import OsApple from '../../assets/icons/os/os-apple.svg';
import OsLinux from '../../assets/icons/os/os-linux.svg';
import OsWindows from '../../assets/icons/os/os-windows.svg';
import Likelihood from '../../assets/icons/likelihood.svg';
import Exposure from '../../assets/icons/exposure.svg';
import VPatch from '../../assets/icons/vpatch.svg';
import Badge from '../../assets/icons/badge.svg';
import Key from '../../assets/icons/key.svg';
import Avatar from '../../assets/icons/avatar.svg';
import Missing from '../../assets/icons/missing.svg';
import ExclamationMark from '../../assets/icons/exclamation-mark.svg';

// confidences
import Confidence40 from '../../assets/icons/confidences/confidence40.svg';
import Confidence80 from '../../assets/icons/confidences/confidence80.svg';
import Confidence95 from '../../assets/icons/confidences/confidence95.svg';
import Confidence99 from '../../assets/icons/confidences/confidence99.svg';
import Confidence100 from '../../assets/icons/confidences/confidence100.svg';

import ConfidenceThick10 from '../../assets/icons/confidences/confidence-thick-10.svg';
import ConfidenceThick20 from '../../assets/icons/confidences/confidence-thick-20.svg';
import ConfidenceThick30 from '../../assets/icons/confidences/confidence-thick-30.svg';
import ConfidenceThick40 from '../../assets/icons/confidences/confidence-thick-40.svg';
import ConfidenceThick50 from '../../assets/icons/confidences/confidence-thick-50.svg';
import ConfidenceThick60 from '../../assets/icons/confidences/confidence-thick-60.svg';
import ConfidenceThick70 from '../../assets/icons/confidences/confidence-thick-70.svg';
import ConfidenceThick80 from '../../assets/icons/confidences/confidence-thick-80.svg';
import ConfidenceThick90 from '../../assets/icons/confidences/confidence-thick-90.svg';
import ConfidenceThick95 from '../../assets/icons/confidences/confidence-thick-95.svg';
import ConfidenceThick99 from '../../assets/icons/confidences/confidence-thick-99.svg';
import ConfidenceThick100 from '../../assets/icons/confidences/confidence-thick-100.svg';

// bars
import BarLevel1 from '../../assets/icons/bar-level-1.svg';
import BarLevel2 from '../../assets/icons/bar-level-2.svg';
import BarLevel3 from '../../assets/icons/bar-level-3.svg';
import BarLevel4 from '../../assets/icons/bar-level-4.svg';

// sectors
import AllSectors from '../../assets/icons/sectors/all-sectors.svg';
import Automotive from '../../assets/icons/sectors/automotive.svg';
import BusinessServices from '../../assets/icons/sectors/business-services.svg';
import Charity from '../../assets/icons/sectors/charity.svg';
import ChemicalsAndAlliedProducts from '../../assets/icons/sectors/chemicals-and-allied-products.svg';
import Construction from '../../assets/icons/sectors/construction.svg';
import CriticalInfrastructures from '../../assets/icons/sectors/critical-infrastructures.svg';
import Cryptocurrency from '../../assets/icons/sectors/cryptocurrency.svg';
import Blast from '../../assets/icons/blast.svg';
import Defense from '../../assets/icons/sectors/defense.svg';
import Education from '../../assets/icons/sectors/education.svg';
import Energy from '../../assets/icons/sectors/energy.svg';
import Entertainment from '../../assets/icons/sectors/entertainment.svg';
import Finance from '../../assets/icons/sectors/finance.svg';
import FoodAndKindredProducts from '../../assets/icons/sectors/food-and-kindred-products.svg';
import Gambling from '../../assets/icons/sectors/gambling.svg';
import Government from '../../assets/icons/sectors/government.svg';
import Healthcare from '../../assets/icons/sectors/healthcare.svg';
import InsuranceAgentsBrokersAndService from '../../assets/icons/sectors/insurance-agents-brokers-and-service.svg';
import Journalism from '../../assets/icons/sectors/journalism.svg';
import Manufacturing from '../../assets/icons/sectors/manufacturing.svg';
import Media from '../../assets/icons/sectors/media.svg';
import Mining from '../../assets/icons/sectors/mining.svg';
import RealEstate from '../../assets/icons/sectors/real-estate.svg';
import Region from '../../assets/icons/sectors/region.svg';
import Retail from '../../assets/icons/sectors/retail.svg';
import Technology from '../../assets/icons/sectors/technology.svg';
import Telecommunication from '../../assets/icons/sectors/telecommunication.svg';
import Tourism from '../../assets/icons/sectors/tourism.svg';
import Transportation from '../../assets/icons/sectors/transportation.svg';
import Maintenance from '../../assets/icons/maintenance.svg';
import Quantum from '../../assets/icons/quantum.svg';
import EmptyTable from '../../assets/icons/empty-table-state.svg';
import OrnamentWaves from '../../assets/icons/ornament-waves.svg';
import OrnamentCircles from '../../assets/icons/ornament-circles.svg';
import NoteIcon from '../../assets/icons/note.svg';
import EuRegion from '../../assets/icons/regions/eu-region.svg';
import UsRegion from '../../assets/icons/regions/us-region.svg';
import AuRegion from '../../assets/icons/regions/au-region.svg';
import Seen from '../../assets/icons/seen.svg';
import NotSeen from '../../assets/icons/not_seen.svg';
import Cloudflare from '../../assets/icons/cloudflare.svg';
import CloudflareLogo from '../../assets/icons/CloudflareLogo.svg';

// snackbar
import SnackbarSuccess from '../../assets/icons/snackbar/success.svg';
import SnackbarError from '../../assets/icons/snackbar/error.svg';
import SnackbarWarning from '../../assets/icons/snackbar/warning.svg';
import SnackbarInfo from '../../assets/icons/snackbar/info.svg';
import SnackbarClose from '../../assets/icons/snackbar/close.svg';
import MenuFloating from '../../assets/icons/menu-floating.svg';
import MenuToggle from '../../assets/icons/menu-toggle.svg';

export const FixedIconsMap = {
  EmptyTable,
  OrnamentWaves,
  OrnamentCircles,
  MenuFloating,
  MenuToggle
};

const bars = {
  BarLevel1,
  BarLevel2,
  BarLevel3,
  BarLevel4
};

const sectors = {
  AllSectors,
  Automotive,
  BusinessServices,
  Charity,
  ChemicalsAndAlliedProducts,
  Construction,
  CriticalInfrastructures,
  Cryptocurrency,
  Defense,
  Education,
  Energy,
  Entertainment,
  Finance,
  FoodAndKindredProducts,
  Gambling,
  Government,
  Healthcare,
  InsuranceAgentsBrokersAndService,
  Journalism,
  Manufacturing,
  Media,
  Mining,
  RealEstate,
  Region,
  Retail,
  Technology,
  Telecommunication,
  Tourism,
  Transportation
};

export const FixedColorsIcons = {
  /** TODO create a map of icons with predefined colors to prevent color and background-color behavior on select */
  CP,
  CPLogoWatermark,
  PanoptesFullEye,
  EuRegion,
  UsRegion,
  AuRegion,
  Confidence40,
  Confidence80,
  Confidence95,
  Confidence99,
  Confidence100,
  ConfidenceThick10,
  ConfidenceThick20,
  ConfidenceThick30,
  ConfidenceThick40,
  ConfidenceThick50,
  ConfidenceThick60,
  ConfidenceThick70,
  ConfidenceThick80,
  ConfidenceThick90,
  ConfidenceThick95,
  ConfidenceThick99,
  ConfidenceThick100,
  VeryHighIcon,
  HighIcon,
  MediumIcon,
  LowIcon,
  InfoIcon,
  SnackbarSuccess,
  SnackbarError,
  SnackbarWarning,
  SnackbarInfo,
  SnackbarClose,
  IndeterminateCheckbox,
  IndeterminateDisabledCheckbox,
  SelectedCheckbox,
  SelectedDisabledCheckbox,
  Checkbox,
  DisabledCheckbox,
  CheckedRadio,
  CheckedDisabledRadio,
  UnCheckedRadio,
  UnCheckedDisabledRadio,
  Add,
  Filters,
  Accepted,
  Quantum,
  NoteIcon,
  Instagram,
  Facebook,
  X,
  LinkedIn,
  Telegram,
  Tiktok,
  Slack,
  Teams,
  OsWindows
};

/** TODO - write script that generates this file automatically for each svg file (Maybe then rename the files or use some replacement to -_ and apply some file-name.svg to CamelCases FileName */
export const IconsMap = {
  ExposureMgmt,
  Home,
  HomeNg,
  Asset,
  Alert,
  Remediation,
  ThreatInvestigation,
  IoCs,
  Siren,
  Radar,
  Investigation,
  InvestigationRequest,
  Chain,
  Monitor,
  Shield,
  ShieldTarget,
  ShieldEnforced,
  ShieldAvailable,
  ShieldUnavailable,
  AcceptedShield,
  RejectedShield,
  ThreatIntel,
  ThreatIntelNg,
  Blast,
  Books,
  Dashboard,
  GridView,
  TableList,
  Gear,
  Tenants,
  Arrow,
  PrevArrow,
  NextArrow,
  DownArrow,
  Search,
  Notification,
  Info,
  Lock,
  Target,
  OnlineHelpIcon,
  Fire,
  Likelihood,
  Exposure,
  VPatch,
  AddBare,
  Archive,
  ArchiveRestore,
  Pin,
  PinOff,
  Flag,
  Delete,
  Edit,
  Edited,
  EditPage,
  FiltersBare,
  ThreeDots,
  Email,
  Clock,
  Coins,
  Close,
  Collapse,
  Expand,
  Shrink,
  Triangle,
  TriangleGrab,
  Tag,
  Ribbon,
  RibbonOutlined,
  Picture,
  Globe,
  Ip,
  Cloud,
  Subdomain,
  Organization,
  CloudAccount,
  Report,
  Upload,
  Pdf,
  Share,
  Chat,
  ChatTakedown,
  Attachments,
  Refresh,
  Reload,
  Copy,
  Download,
  Save,
  Check,
  CheckOutlined,
  ExportToCSV,
  ExportToXlsx,
  Calendar,
  DiscoveryPath,
  ParkedDomain,
  Play,
  Thumb,
  Success,
  ClipboardCheck,
  Fail,
  InProgress,
  Error,
  Abort,
  Warning,
  WarningHex,
  Minimize,
  Fingerprint,
  Popular,
  History,
  Location,
  RelatedAlert,
  Phishing,
  Phone,
  Work,
  Users,
  Copyright,
  WorkAlert,
  Imposter,
  Other,
  ExposedFile,
  Escalation,
  Ban,
  Bug,
  Trademark,
  PenSquare,
  Link,
  LinkCircle,
  Visibility,
  VisibilityOff,
  ArrowDirection,
  DoneAll,
  Image,
  AccountCircle,
  ArtificialIntelligence,
  AI: ArtificialIntelligence,
  AiSparkle,
  StarSparkle,
  Star,
  Severity,
  CalendarDefault,
  Folder,
  FolderOpen,
  Heart,
  HeartPlus,
  MoveTo,
  OpenInBrowser,
  Settings,
  ThumbDown,
  Translate,
  Theme,
  Sun,
  Moon,
  CreateAlert,
  CreateAlertFilled,
  Plus,
  Send,
  LockOpen,
  Eraser,
  ExpandWidth,
  ShrinkWidth,
  Maintenance,
  Owner,
  Badge,
  Key,
  Avatar,
  Missing,
  Exploit,
  GraduationCap,
  Alpha,
  Beta,
  ExclamationMark,
  AlertActive,
  AlertInactive: CreateAlert,
  Seen,
  NotSeen,
  Map,
  Cloudflare,
  CloudflareLogo,
  DropletFilled,
  DropletOutlined,
  Pending,
  VT,
  PlayBare,
  Wrench,
  Door,
  LogOut,
  Network,
  Ticket,
  Broadcast,
  CursorClick,
  FilledFlag,
  OutlinedFlag,
  OsApple,
  OsLinux,
  ...sectors,
  ...bars
};
